<template>
    <div id="bannerAdmin">

        <div class="header">
            <!-- 面包屑导航 -->
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item>开屏广告列表</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <!-- 搜索和添加 -->
        <div class="searchBox">
            <el-form :inline="true" style="margin-top: 20px;">
                <el-form-item>
                    <el-button size="small" type="primary" icon="el-icon-plus" @click="btnAddBanner">添加</el-button>
                </el-form-item>
            </el-form>
        </div>

        <div class="content">
            <!--列表-->
            <el-table size="small" :data="bannerList" highlight-current-row border element-loading-text="拼命加载中"
                style="width: 100%;" height="100%" v-horizontal-scroll>

                <el-table-column align="center" prop="url" label="视频" width="220">
                    <template slot-scope="scope">
                        <video :src="scope.row.url" style="width: 80px;height: 80px;" v-if="scope.row.url" controls>
                            Your browser does not support the video tag.
                        </video>
                        <div v-if="scope.row.url == null">没有视频</div>
                    </template>
                </el-table-column>
                <el-table-column align="center" prop="seconds" label="开屏时间" width="160">
                    <template slot-scope="scope">
                        {{ scope.row.seconds }}s
                    </template>
                </el-table-column>
                <el-table-column align="center" prop="state" label="状态">
                    <template slot-scope="scope">
                        <div>
                            <el-switch v-model="scope.row.state == 1 ? true : false" active-color="#13ce66"
                                inactive-color="#ff4949">
                            </el-switch>
                            {{ scope.row.state == 1 ? '开启' : '关闭' }}
                        </div>

                    </template>
                </el-table-column>
                <el-table-column align="center" label="操作" width="160" fixed="right">
                    <template slot-scope="scope">
                        <el-button size="mini" type="primary" @click="openAct(scope.row)">修改</el-button>
                        <el-button size="mini" type="danger" @click="deleAct(scope.row)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>


        <!-- 添加广告 -->
        <el-dialog :title="bannerType == 'add' ? '添加广告' : '编辑广告'" v-if="bannerVisible" :visible.sync="bannerVisible"
            width="40%">

            <div class="addBannerBox">
                <el-form label-width="120px" :model="formData" :rules="formRules" ref="ruleForm">

                    <el-form-item label="开屏广告" prop="url">
                        <div style="display: flex; align-items: center;">
                            <video v-if="formData.url != ''" :src="formData.url"
                                style="width: 140px;height: 140px;margin-left: 14px;" controls>
                                Your browser does not support the video tag.
                            </video>
                            <el-upload action="" :http-request="mainImgUpload" :show-file-list="false"
                                list-type="picture-card">
                                <i class="el-icon-plus"></i>
                            </el-upload>
                        </div>
                    </el-form-item>
                    <el-form-item label="广告显示秒数" prop="seconds">
                        <el-input size="small" v-model="formData.seconds" auto-complete="off"
                            placeholder="请输入开屏广告时间"></el-input>
                    </el-form-item>
                    <el-form-item label="开启状态" prop="state">
                        <el-radio v-model="formData.state" label="1">开启</el-radio>
                        <el-radio v-model="formData.state" label="0">关闭</el-radio>
                    </el-form-item>
                </el-form>

            </div>

            <span slot="footer" class="dialog-footer">
                <el-button size="small" @click="bannerVisible = false">取 消</el-button>
                <el-button size="small" type="primary" @click="btnSubmitBanner">{{ bannerType == 'add' ? '确 定' : '编 辑'}}</el-button>
            </span>
        </el-dialog>

    </div>
</template>

<script>
import client from "@/utils/ossClient.js";
import Pagination from '../../components/Pagination'

import { addBannerAPi, bannerInfoAPi, editBannerAPi, delBannerAPi } from '@/api/banner_admin.js'

// 工具栏配置
const toolbarOptions = [
    ["bold", "italic", "underline", "strike"], // toggled buttons
    ["blockquote", "code-block"],

    [{ header: 1 }, { header: 2 }], // custom button values
    [{ list: "ordered" }, { list: "bullet" }],
    [{ script: "sub" }, { script: "super" }], // superscript/subscript
    [{ indent: "-1" }, { indent: "+1" }], // outdent/indent
    [{ direction: "rtl" }], // text direction

    [{ size: ["small", false, "large", "huge"] }], // custom dropdown
    [{ header: [1, 2, 3, 4, 5, 6, false] }],

    [{ color: [] }, { background: [] }], // dropdown with defaults from theme
    [{ font: [] }],
    [{ align: [] }],
    ["link", "image", "video"], // 对于图片上传这是重点
    ["clean"], // remove formatting button
];
export default {
    data() {
        return {
            bannerList: [], //广告列表
            bannerVisible: false,
            formData: {
                url: '',
                seconds: '',
                state: '1', // 0 关闭，1 打开
            },
            formRules: {
                url: [
                    { required: true, message: '请上传图片', trigger: 'blur' },
                ],
                state: [
                    { required: true, message: '请选择开启状态', trigger: 'change' }
                ],
                seconds: [
                    { required: true, message: '请输入开屏广告时间', trigger: 'blur' }
                ],
            },
            bannerType: 'add'
        }
    },
    created() {
        this.bannerInfoData()
    },
    // 注册组件
    components: {
        Pagination
    },
    computed: {

    },
    methods: {

        // 查看广告 
        bannerInfoData() {
            let that = this
            that.bannerList = []
            bannerInfoAPi({

            }).then(res => {
                if (res.code == 200) {
                    that.bannerList.push(res.data.data)
                }
            })

        },

        // 修改广告
        openAct(item) {
            this.bannerVisible = true
            this.bannerType = 'edit'
            item.state = JSON.stringify(item.state)
            this.formData = item
        },
        // 删除广告
        deleAct(item) {
            this.$confirm('确定删除吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'error'
            }).then(() => {
                let data = {
                    id: item.id
                }
                delBannerAPi(data).then(res => {
                    if (res.code == 200) {
                        this.bannerInfoData()
                        this.$message.success(res.msg)
                    } else {
                        this.$message.error(res.msg);
                    }
                })
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });
            });
        },
        // 添加广告 
        btnAddBanner() {
            this.bannerVisible = true
            this.bannerType = 'add'
            this.formData = {
                url: '',
                seconds: '',
                state: '0', // 0 关闭，1 打开
            }
        },
        // 确定添加广告
        btnSubmitBanner() {
            let that = this
            console.log(this.formData)
            this.$refs['ruleForm'].validate((valid) => {
                if (valid) {

                    if (that.bannerType == 'add') {
                        addBannerAPi({
                            ...that.formData
                        }).then(res => {
                            if (res.code == 200) {
                                this.bannerInfoData()
                                that.bannerVisible = false
                                that.formData = {
                                    url: '',
                                    seconds: '',
                                    state: '1', // 0 关闭，1 打开
                                }
                            } else {
                                this.$message.error(res.msg);
                            }
                        })
                    } else if (that.bannerType == 'edit') {
                        console.log(that.formData,'编辑数据')
                        editBannerAPi({
                            ...that.formData
                        }).then(res => {
                            if (res.code == 200) {
                                that.bannerVisible = false
                                this.bannerInfoData()
                                that.formData = {
                                    url: '',
                                    seconds: '',
                                    state: '1', // 0 关闭，1 打开
                                }
                            } else {
                                this.$message.error(res.msg);
                            }
                        })
                    }


                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        // 自定义上传方法
        mainImgUpload(file) {
            // 判断扩展名
            const tmpcnt = file.file.name.lastIndexOf(".");
            const exname = file.file.name.substring(tmpcnt + 1);
            const names = ["jpg", "jpeg", "webp", "png", "bmp"];
            // if (names.indexOf(exname) < 0) {
            //     this.$message.error("不支持的格式!");
            //     return;
            // }
            const fileName = file.file.uid + "." + exname;
            client
                .put(fileName, file.file)
                .then((res) => {
                    if (res.url) {
                        this.formData.url = res.url
                        // this.image.push(res.url)
                    } else {
                        this.$message.error("文件上传失败");
                    }
                })
                .catch((err) => { });
        },

    }

}
</script>

<style>
#bannerAdmin {
    height: 100%;
    display: flex;
    flex-direction: column;
}

#bannerAdmin .header {
    flex: none;
}

#bannerAdmin .searchBox {
    flex: none;
}

#bannerAdmin .content {
    flex: auto;

}
</style>



// WEBPACK FOOTER //
// src/views/banner_admin/banner_list.vue